export default {
  oddsFormat: {
    en: 'Odds Format',
  },
  timeFormat: {
    en: 'Time Format',
  },
}
